<template>
  <nav>
    <v-toolbar color="primary" dark dense flat app extended extension-height="1" >
      <v-toolbar-title class="text-uppercase white--text">
        <img src="/ashyaat-logo.png" width="80px" style="margin-top:5px" alt="">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="cartcount==0" :style="`${language == 'ar' ? 'direction:rtl;font-size:26px;white-space: nowrap;' : 'font-size:20px;white-space: nowrap;'}`" :class="`white--text ${language == 'ar' ? 'arFont' : null}`">{{ locale[language]['lowest'+newCountry] }}</span>
     
      <v-menu offset-y v-if="false">
        <v-btn slot="activator" icon>
          <v-icon color="white">apps</v-icon>
        </v-btn>
          
        <v-list>
          <v-btn @click="logout" flat color="grey">
            <span>Sign Out</span>
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-list>
      </v-menu>
    </v-toolbar>
    
  </nav>
  
</template>

<script>
import Popup from './Popup'
import {firebase, auth, db} from '@/fb';


export default {
  components: { Popup },
  data() {
    return {
      drawer: false,
      imports:null,
      snackbar: false,
      locale: {
        en: {
          total: 'Total',
          finish_order:'Finish Order',
          lowestJO:`Lowest Prices In Jordan`,
          lowestSA:`Lowest Prices In KSA`
        },
        ar:{
          total: 'المجموع',
          finish_order:'انهاء الشراء',
          lowestJO:`اقل اسعار في الاردن`,
          lowestSA:`اقل اسعار في السعودية`
        }
      }
    }
  },
  methods: {
    
    logout: function() {
      auth.signOut();
    },
    goTo(path) {
      this.$router.push(path)
    }
  },
  props: {
    connection: {
      required: true,
      default: 'error'
    },
    userName: {
      required: true,
      default: 'ASHYAA'
    },
    newCountry: {
      default: null
    },
    userImage: {
      required: true,
      default: ''
    },
    progress:{
      default: false
    },
    scroll:{
      default: false
    },
    superAdmin:{
      default: false
    },
    scrollAmount: {
      default: 0
    },
    cartcount: {
      default: 0
    },
    cartTotal: {
      default: 0
    },
    symbol:{
      default: '$'
    },
    language:{
      default:'en'
    }
  },
  computed:{
    
  },
  watch:{
    
  },
  created () {
  }
}
</script>

<style>
.v-toolbar__extension {
    padding: 0 !important;
}
</style>
